import { c as _c } from "react/compiler-runtime";
import { faCheck, faLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { SurveyHome } from '@/models/survey';
import { copyToClipboard } from '@/utils/clipboard';
import { SURVEY_STATUS } from '@/utils/constants';
type CopySharingLinkProps = {
  survey: SurveyHome;
};
export const CopySharingLink = t0 => {
  const $ = _c(10);
  const {
    survey
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("link.copy");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [copyLinkTooltip, setCopyLinkTooltip] = useState(t1);
  let t2;
  if ($[2] !== survey.id || $[3] !== t) {
    t2 = async event => {
      event.stopPropagation();
      ;
      try {
        const url = `${window.location.origin}/${survey.id}`;
        await copyToClipboard(url);
        setCopyLinkTooltip(t("copied", {
          ns: "common"
        }));
        setTimeout(() => {
          setCopyLinkTooltip(t("link.copy"));
        }, 2000);
      } catch (t3) {
        const error = t3;
        console.error("Erreur lors de la copie:", error);
        setCopyLinkTooltip(t("error", {
          ns: "common"
        }));
        setTimeout(() => {
          setCopyLinkTooltip(t("link.copy"));
        }, 2000);
      }
    };
    $[2] = survey.id;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCopyLink = t2;
  let t3;
  if ($[5] !== copyLinkTooltip || $[6] !== handleCopyLink || $[7] !== survey.status.label || $[8] !== t) {
    t3 = survey.status.label !== SURVEY_STATUS.OPEN ? <button className="flex size-8 cursor-not-allowed items-center justify-center rounded-md opacity-40" disabled={true} onClick={_temp}><FontAwesomeIcon size="lg" icon={faLink} /></button> : <div className="relative"><Tooltip content={copyLinkTooltip} placement="top" size="sm" trigger={<button className="relative flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors" onClick={event_1 => handleCopyLink(event_1)}><FontAwesomeIcon size="lg" icon={copyLinkTooltip === t("copied", {
          ns: "common"
        }) ? faCheck : faLink} className={copyLinkTooltip === t("copied", {
          ns: "common"
        }) ? "text-green-600" : ""} />{copyLinkTooltip === t("copied", {
          ns: "common"
        }) && <span className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 text-xs font-medium whitespace-nowrap text-green-600">{t("copied", {
            ns: "common"
          })}</span>}</button>} /></div>;
    $[5] = copyLinkTooltip;
    $[6] = handleCopyLink;
    $[7] = survey.status.label;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(event_0) {
  return event_0.stopPropagation();
}